import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // Hookless, error-proof check to avoid invalid React dispatcher issues
  if (typeof window === "undefined") return false
  try {
    const isMatch = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
    return isMatch
  } catch {
    return window.innerWidth < MOBILE_BREAKPOINT
  }
}
